import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fetchDiagnostic = async (lang = "es") => {
  const { data } = await axios.get(`${API}/diagnostic`, { params: { lang } });
  return data;
};

export const submitAssessment = async (answers, baseline, language = "es") => {
  const { data } = await axios.post(`${API}/assessments`, { answers, baseline, language, source: "web" });
  return data;
};

export const getAssessment = async (id, lang = "es") => {
  const { data } = await axios.get(`${API}/assessments/${id}`, { params: { lang } });
  return data;
};

export const submitFeedback = async (id, feedback) => {
  const { data } = await axios.post(`${API}/assessments/${id}/feedback`, feedback);
  return data;
};

export const getJournal = async (id) => {
  const { data } = await axios.get(`${API}/assessments/${id}/journal`);
  return data;
};

export const saveJournalDay = async (id, entry) => {
  const { data } = await axios.post(`${API}/assessments/${id}/journal`, entry);
  return data;
};

export const fetchAnalytics = async (token) => {
  const { data } = await axios.get(`${API}/admin/analytics`, { headers: { "X-Admin-Token": token } });
  return data;
};

export const previewCleanup = async (token) => {
  const { data } = await axios.get(`${API}/admin/cleanup/preview`, { headers: { "X-Admin-Token": token } });
  return data;
};

export const runCleanup = async (token) => {
  const { data } = await axios.post(`${API}/admin/cleanup`, { confirm: true }, { headers: { "X-Admin-Token": token } });
  return data;
};

export const SEVERITY_COLORS = {
  low: "#475F51",
  moderate: "#A68A56",
  high: "#A96143",
  critical: "#8C3333",
};
